import React from "react";
import { ActionIcon, Box, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import {
  ProviderOption,
  ProviderOptionList,
} from "../sheets/ProviderOptionList";
import styles from "./MobileDetailSheet.module.css";

export type { ProviderOption };

export interface MobileProviderPickerProps {
  options: ProviderOption[];
  selectedId: string;
  onPick: (id: string) => void;
  onClose: () => void;
}

/**
 * Full-cover "Select provider" picker (design 2.5): covers the sheet, titled
 * header + close X, then the shared provider rows (`ProviderOptionList`).
 */
export const MobileProviderPicker: React.FC<MobileProviderPickerProps> = ({
  options,
  selectedId,
  onPick,
  onClose,
}) => (
  <Box
    className={styles.cover}
    role="dialog"
    aria-label="Select provider"
    data-testid="mobile-provider-picker"
  >
    <Box className={styles.coverHead}>
      <Text className={styles.coverTitle}>Select provider</Text>
      <ActionIcon
        variant="default"
        className={styles.iconBtn}
        onClick={onClose}
        aria-label="Close"
      >
        <IconX size={17} stroke={1.8} />
      </ActionIcon>
    </Box>
    <Box className={styles.coverList}>
      <ProviderOptionList
        options={options}
        selectedId={selectedId}
        onPick={onPick}
      />
    </Box>
  </Box>
);
